<template>
  <div class="doctype-modal" @keydown.esc="close">
    <u-confirm id="delete-doctype" ref="confirm" />

    <c-sidesheet :active="active" :title="id ? 'Редактирование типа анализа' : 'Новый тип анализа'" @close="close">
      <template #actions>
        <div v-if="id" class="layout-header-action">
          <c-button-2
            size="small"
            label="Удалить"
            :disabled="!canDeleteType"
            :icon="{
              icon: 'trash',
              color: 'secondary',
            }"
            @click="deleteAnalyseType"
          />
        </div>
      </template>
      <div class="doctype-form">
        <div class="doctype-form">
          <div class="doctype-form__name">
            <c-input-2
              v-model="form.name"
              floating-label="Наименование анализа"
              :required="submitted && nameError"
              :required-message="submitted && nameError"
              :required-mark="true"
              :style="{
                'margin-bottom': submitted && nameError ? '50px' : '',
              }"
              :max-length="255"
              :clearable="true"
            ></c-input-2>
          </div>

          <div class="doctype-form__description">
            <c-textarea
              ref="description"
              v-model="form.description"
              floating-label="Описание"
              type="textarea"
              :max-length="500"
              :clearable="true"
            ></c-textarea>
          </div>
        </div>

        <div class="doctype-form__actions">
          <c-button-2 size="large" class="doctype-form__reset" label="Отменить" @click="reset" />

          <c-button-2
            class="doctype-form__save"
            label="Сохранить"
            color="primary"
            size="large"
            :disabled="pending"
            @click="submit"
          />
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import Sidesheet from "@/components/sidesheet";
import Input2 from "@/components/controls2/Input";
import Button2 from "@/components/controls2/Button";
import Textarea from "@/components/textarea";
import Confirm from "@/pages/documents/u-confirm";

export default {
  name: "medical-analyses-sidesheet",

  components: {
    "c-sidesheet": Sidesheet,
    "c-input-2": Input2,
    "c-textarea": Textarea,
    "c-button-2": Button2,
    "u-confirm": Confirm,
  },

  data() {
    return {
      active: false,
      id: "",
      submitted: false,
      pending: false,
      isValid: false,

      form: {
        name: "",
        description: "",
      },

      savedData: {},
    };
  },

  computed: {
    nameError() {
      return this.form.name.trim() ? null : "Обязательное поле";
    },
    canDeleteType() {
      if (this.savedData.analyses) {
        return this.savedData.analyses.length === 0;
      }
      return true;
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },

  methods: {
    setData(analyseType = {}) {
      this.form.name = analyseType.name || "";
      this.form.description = analyseType.description || "";
    },
    open(params) {
      params = params || {};
      const analyseType = params.analyseType || {};
      this.id = analyseType.id;
      this.savedData = analyseType;

      this.setData(analyseType);
      this.active = true;
    },
    close() {
      this.active = false;
      this.savedData = {};
      this.setData();
      this.$emit("close");
    },
    validate() {
      let isValid = true;
      if (this.nameError) isValid = false;

      return isValid;
    },
    submit() {
      this.submitted = true;
      if (!this.validate()) {
        return false;
      }

      this.submitted = false;
      this.pending = true;

      const action = this.id ? "medicalAnalyses/updateAnalyseType" : "medicalAnalyses/createAnalyseType";
      const params = {
        data: this.getParams(),
      };
      if (this.id) {
        params.id = this.id;
      }

      this.$store.dispatch(action, params).then(() => {
        this.pending = false;
        this.$emit("update");
        this.close();
      });

      return true;
    },
    getParams() {
      return {
        name: this.form.name,
        description: this.form.description,
      };
    },
    reset() {
      this.setData(this.savedData);
      this.close();
    },
    deleteAnalyseType() {
      if (this.canDeleteType) {
        this.$emit("delete-type", this.savedData, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

::v-deep .sidesheet__wrapper {
  width: calc(100vw - 161px);
  padding: 38px 31px 38px 31px;

  @media screen and (max-width: 1024px) {
    width: calc(100vw - 62px);
  }

  @media screen and (max-width: 700px) {
    padding: 28px 20px;
    max-width: 100%;
    width: 100%;
  }
}

.doctype-form {
  margin-top: 32px;

  &__name {
    margin-bottom: 22px;
  }

  &__name,
  &__description {
    max-width: 565px;
  }

  &-issues {
    margin-top: 40px;

    h2 {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    &__colors {
      display: flex;
    }

    &__color {
      margin-right: 35px;
    }
  }

  &__actions {
    margin-top: 25px;
    display: flex;
    align-items: center;
  }

  &__reset {
    margin-right: 10px;
    width: 120px;
    padding: 0;
    background: #fff;
  }

  &__save {
    width: 125px;
    padding: 0;
  }

  &__name {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 1024px) {
    &__name,
    &__description {
      width: 100%;
      max-width: 680px;
    }
  }
}

@media (max-width: 480px) {
  .doctype-modal {
    position: relative;
  }
  .doctype-form__actions {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .doctype-form__actions button {
    width: 50%;
    margin: 0;
    border-radius: 0;
  }
}
</style>
